import moment, { unitOfTime } from 'moment';

export const checkIsBefore = (first?: string | Date, second?: string | Date, unit?: unitOfTime.StartOf): boolean => {
    return moment(first).isBefore(second, unit);
};
